import { useState } from 'react';
import { faqs } from '@/mocks/downloadData';

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8 text-center">
          <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-medium tracking-wide">
            <i className="ri-question-line"></i>
            FAQ
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide">
            常见问题解答
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
            下载、安装与访问过程中最常被问到的几个问题，点击标题即可展开查看。
          </p>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden divide-y divide-background-200">
          {faqs.map((item, idx) => {
            const open = openIndex === idx;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  aria-expanded={open}
                  onClick={() => setOpenIndex(open ? null : idx)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <span className="flex items-start gap-3">
                    <span className="w-6 h-6 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 text-xs shrink-0 mt-0.5">
                      Q
                    </span>
                    <span className="text-foreground-950 text-sm md:text-base font-medium leading-relaxed">{item.q}</span>
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-500 text-xl shrink-0 transition-transform duration-300 ${
                      open ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-14">
                    <p className="text-foreground-600 text-sm leading-relaxed">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}